<template>
  <div>
    <div
      class="quote-status-info text-center p-4 approved"
      v-if="quote.status === 4"
    >
      <h6 class="status-title">¡Cotización aprobada!</h6>
      <p class="status-text">
        Para solicitar ajustes sobre la misma, contacta a
        {{ quote.owner.name }} {{ quote.owner.last_name }}
        <br />
        al correo {{ quote.owner.email }}
      </p>
    </div>
    <div
      class="quote-status-info text-center p-4 rejected"
      v-if="quote.status === 7"
    >
      <h6 class="status-title">Cotizacion rechazada</h6>
      <p class="status-text">
        Para solicitar una revisión adicional, contacta a
        {{ quote.owner.name }} {{ quote.owner.last_name }}
        <br />
        al correo {{ quote.owner.email }} para solicitar una nueva.
      </p>
    </div>
    <div
      class="quote-status-info text-center p-4 expired"
      v-if="quote.status === 6"
    >
      <h6 class="status-title">Cotizacion expirada</h6>
      <p class="status-text">
        La oferta presentada ha caducado, contacta a {{ quote.owner.name }}
        {{ quote.owner.last_name }}
        <br />
        al correo {{ quote.owner.email }} para solicitar una nueva.
      </p>
    </div>
    <div class="container-fluid">
      <div
        class="row py-5"
        v-bind:style="{
          backgroundColor:
            templateData.colors != undefined
              ? templateData.colors[1].color_value + ' !important'
              : 'white',
        }"
      >
        <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 offset-xl-1 offset-lg-1 offset-md-0 offset-sm-0 offset-0 p-xl-0 p-lg-0">
          <div class="container card-container-quote-preview p-0">
            <div class="card">
              <!-- Upper body -->
              <pdf-master
                :template_configuration="templateData"
                :quote_data="quote"
                v-if="dataLoaded"
              ></pdf-master>
              <!-- Mid body -->
              <div
                class="row secondary-padding light-text pt-0"
                v-bind:style="{
                  fontFamily:
                    templateData.selected_font + ', sans-serif !important',
                }"
              >
                <div class="col-12">
                  <h3
                    class="font-weight-bold strong-text"
                    v-bind:style="{
                      color:
                        templateData.colors != undefined
                          ? templateData.colors[2].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    {{ quote.details.title }}
                  </h3>

                  <p
                    v-if="hasProducts"
                    v-bind:style="{
                      color:
                        templateData.colors != undefined
                          ? templateData.colors[4].color_value + ' !important'
                          : 'white',
                    }"
                  >
                    Total {{ getTotal | currency }}
                    {{ quote.details.currency }} con IVA:
                    {{ justTaxes | currency }} ({{ optionalsSelected }} de
                    {{ optionals }} opciones seleccionadas)
                  </p>

                  <p v-for="(suscription,index) in suscriptions" :key="index" v-bind:style="{color : templateData.colors != undefined ? templateData.colors[4].color_value+' !important' : 'white'}">
                    Subscripción <b>{{suscription.title}}</b> total de {{getSuscriptionTotal(suscription.total, suscription.tax) | currency}}  <span v-if="quote.tax"> con IVA.</span>
                  </p>

                  <div class="mb-4" v-if="quote.status == 2">
                    <strong
                      class="d-block mb-2"
                      v-bind:style="{
                        color:
                          templateData.colors != undefined
                            ? templateData.colors[4].color_value + ' !important'
                            : 'white',
                      }"
                    >
                      Comentarios adicionales:
                    </strong>
                    <textarea
                      v-model="quote.comments"
                      class="w-75 p-2 extra-notes"
                      cols="10"
                      rows="3"
                      placeholder="Opcional"
                    ></textarea>
                  </div>

                  <div v-else>
                    <div
                      v-if="
                        quote.details.comments != null &&
                        quote.details.comments != 'null'
                      "
                    >
                      <strong class="d-block mb-2"
                        >Comentarios adicionales:</strong
                      >
                      <p>{{ quote.details.comments }}</p>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center mb-4"
                    v-if="quote.status == 2"
                  >
                    <input type="checkbox" id="auth-check" @click="checkAuthorization()"/>
                    <label class="ml-3 my-0" for="auth-check" v-bind:style="{ color: templateData.colors != undefined ? templateData.colors[4].color_value + ' !important' : 'white',}">
                      Yo, {{ quote.clients[0].name }}, apruebo esta cotización el {{ this.approveDate }} a las {{ this.approveHour }} hrs
                    </label>
                  </div>


                  <div class="button-wrapper" v-if="quote.status == 2">
                    <button
                      id="approve-btn"
                      class="btn disabled mr-2"
                      v-bind:style="{
                        backgroundColor:
                          templateData.colors != undefined
                            ? templateData.colors[0].color_value
                            : 'white',
                      }"
                      disabled
                      @click.once="approveQuotation()"
                    >
                      Aprobar
                    </button>
                    <button
                      class="btn btn-outlined"
                      @click.once="declineQuotation()"
                      v-bind:style="{
                        border:
                          templateData.colors != undefined
                            ? 'solid 1px ' +
                              templateData.colors[0].color_value +
                              ' !important'
                            : 'white',
                        color:
                          templateData.colors != undefined
                            ? templateData.colors[4].color_value + ' !important'
                            : 'white',
                      }"
                    >
                      Rechazar
                    </button>
                  </div>

                </div>
              </div>
              <pdf-footer-master
                :template_configuration="templateData"
                :quote_data="quote"
                v-if="dataLoaded"
              ></pdf-footer-master>
              <!-- Footer -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* importacion api servicios */

import cotizacionInfoService from "@/api/quotation_detail";
/* Importacion extras */
import moment from "moment";
import data from "@/mixins/data";
import methods from "@/mixins/methods";
import filters from "@/mixins/filters";
import { validationMixin } from "vuelidate";

import $ from "jquery";
import PdfMaster from "@/components/pdf/PdfMaster";
import PdfFooterMaster from "@/components/pdf/PdfFooterMaster";

export default {
  mixins: [data, methods, filters, validationMixin],
  components: {
    PdfMaster,
    PdfFooterMaster,
  },
  beforeMount() {
    $(".tooltip").remove();
    this.loadRequiredData();
    this.approveDate = moment().format("LL");
    this.approveHour = moment().format("LT");
  },
  beforeDestroy() {
    this.$swal.close();
  },
  computed: {
    hasProducts() {
      return this.products.length > 0;
    },

    discountItems() {
      return (
        this.products.reduce((sum, product) => {
          if (!product.optional.active || product.optional.select) {
            return (sum += parseFloat(
              (product.price * product.discount.amount) / 100
            ));
          } else {
            return (sum += 0);
          }
        }, 0) || 0
      );
    },
    optionals() {
      return this.products.filter((item) => item.optional.active).length;
    },
    optionalsSelected() {
      return this.products.filter(
        (item) => item.optional.select == true && item.optional.active == true
      ).length;
    },
    items() {
      return this.quote.items.slice();
    },
    contactsFormatted() {
      return this.contacts.map((old) => {
        return {
          name: `${old.name.firstname} ${old.name.lastname}`,
          company: old.company,
          email: old.email,
        };
      });
    },
    products() {
      return this.quote.items.filter((item) =>
        item.suscription != undefined ? !item.suscription.active : false
      );
    },
    subtotal() {
      return (
        this.products.reduce((sum, product) => {
          if (!product.optional.active || product.optional.select) {
            return (sum += parseFloat(product.total));
          } else {
            return (sum += 0);
          }
        }, 0) || 0
      );
    },
    justTaxes() {
      if (this.quote.tax) {
        return (
          this.products.reduce((sum, product) => {
            if (!product.optional.active || product.optional.select) {
              return product.tax
                ? (sum +=
                    product.total *
                    (1 - this.quote.discount / 100) *
                    (this.quote.tax_value / 100))
                : sum;
            } else {
              return (sum += 0);
            }
          }, 0) || 0
        );
      } else {
        return 0;
      }
    },
    justDiscount() {
      return this.subtotal * (this.quote.discount / 100);
    },
    getTotal() {
      return this.subtotal - this.justDiscount + this.justTaxes;
    },
    suscriptions() {
      return this.quote.items.filter(
        (item) =>
          item.type === "producto" &&
          item.suscription.frequency != null &&
          item.optional.select == true
      );
    },
    headerClass() {
      let headerClass;
      switch (this.quote.status) {
        case 1:
          headerClass = "pending";
          break;
        case 2:
          headerClass = "pending";
          break;
        case 3:
          headerClass = "pending";
          break;
        case 4:
          headerClass = "approved";
          break;
        case 5:
          headerClass = "approved";
          break;
        case 6:
          headerClass = "expired";
          break;
        case 7:
          headerClass = "rejected";
          break;
        default:
          headerClass = "pending";
          break;
      }
      return headerClass;
    },
  },
  data() {
    return {
      approveDate: null,
      approveHour: null,
      dataLoaded: false,
      image: require("@/assets/icons/edit_white.svg"),
      quote: {
        quoteId: null,
        key: null,
        discount: 0,
        currency: "MXN",
        tax: true,
        tax_value: 0,
        title: null,

        historical: {
          date_send: null,
          total_views: 0,
          total_edits: 0,
          history_items: [],
        },
        details: {
          folio: 0,
          date_send: null,
          date_valid: null,
          currency: "",
          notes: null,
          pdf_link: "",
          comments: "",
          signature: {
            datetime: "",
            user_agent: "",
            ip: "",
            mail: "",
            approve_owner: false,
            approve_user_id: 0,
          },
          title: "",
        },
        owner: {
          address: "",
          company: "",
          last_name: "",
          name: "",
          page: "",
          email:""
        },
        clients: [],
        items: [],
        items_text: [],
        status: 0,
        comments: "",
        send_mail: false,
      },
      templateData: {},
    };
  },
  methods: {
    checkAuthorization() {
      if (document.getElementById("auth-check").checked) {
        document.getElementById("approve-btn").removeAttribute("disabled");
        document.getElementById("approve-btn").classList.add('btn-purple');
        document.getElementById("approve-btn").classList.remove('disabled')
        document.getElementById("approve-btn").style.backgroundColor = this.templateData.colors != undefined ? this.templateData.colors[0].color_value : "#200E59";
        this.approveDate = moment().format("LL");
        this.approveHour = moment().format("LT");
      } else {
        document.getElementById("approve-btn").classList.remove('btn-purple');
        document.getElementById("approve-btn").classList.add('disabled')
        document.getElementById("approve-btn").style.backgroundColor = "#D8DFEB"
        document.getElementById("approve-btn").setAttribute("disabled", "true");
      }
    },
    approveQuotation() {
      this.$store.dispatch("showLoader", { show: true });
      let formData = new FormData();
      let token = this.$route.query.token;

      let productos = this.getEditableItems();

      formData.append("comments", this.quote.comments);
      formData.append("token", token);
      formData.append("products", JSON.stringify(productos));

      cotizacionInfoService
        .approveQuotationClient(formData)
        .then(() => {
          let dataPrice = {
            token: this.$route.query.token,
            net_total: this.getTotal,
          }
          cotizacionInfoService.updateTotalClient(dataPrice).then(()=>{
            this.$store.dispatch("showMessage", {
            action: "success",
            message: "Cotización aprobada",
            });
            this.loadRequiredData();
            this.$store.dispatch("showLoader", { show: false });
          }).catch(() => {
            this.$store.dispatch("showLoader", { show: false });
          });

        })
        .catch(() => {
          this.$store.dispatch("showLoader", { show: false });
        });
    },
    declineQuotation() {
      this.$store.dispatch("showLoader", { show: true });
      let formData = new FormData();
      let token = this.$route.query.token;

      formData.append("comments", this.quote.comments);
      formData.append("token", token);

      cotizacionInfoService
        .declineQuotationClient(formData)
        .then(() => {
          this.$store.dispatch("showMessage", {
            action: "success",
            message: "Cotización rechazada",
          });
          this.loadRequiredData();
          this.$store.dispatch("showLoader", { show: false });
        })
        .catch(() => {
          this.$store.dispatch("showLoader", { show: true });
        });
    },
    getSuscriptionTotal(amount, hasTax) {
      const tax = hasTax ? 1 + this.quote.tax_value / 100 : 1;
      const discount =
        this.quote.discount > 0 ? 1 - this.quote.discount / 100 : 1;
      return amount * discount * tax;
    },
    loadRequiredData() {
      this.$store.dispatch("showLoader", { show: true });

      cotizacionInfoService
        .getDetailInfo(this.$route.query.token)
        .then((response) => {
          if (response.data.data.team != null) {
            this.templateData = response.data.data.team;
          } else {
            this.templateData = this.defaultDesign();
          }
          this.formatDetailData(response);
          this.dataLoaded = true;
          this.$store.dispatch("showLoader", { show: false });
        })
        .catch((error) => {
          //Reedirección si la cotizacion se encuentra en status 2 (borrador)
          if (error.data.message == "Cotización no disponible") {
            this.$router.push({path:`/cotizaciones/cliente/detalle/editando`, query:{
              user:error.data.errors.name+" "+error.data.errors.last_name,
              mail:error.data.errors.email
            }});
            //Reedirección si no se encuentra la cotizacion
          } else if (
            error.data.message == "Token invalido" ||
            error.data.message == "Cotización no encontrada"
          ) {
            this.$router.push(`/cotizaciones/cliente/detalle/not_found`);
          }
        });
    },
    formatDetailData(response) {
      /* Cargar datos historicos de cotización */

      /* Cargar datos de cotizacion */
      this.quote.quoteId = response.data.data.quotation.uuid;
      this.quote.details.title = response.data.data.quotation.title;
      this.quote.details.comments = response.data.data.quotation.comments;
      this.quote.details.folio = response.data.data.quotation.folio;
      this.quote.details.pdf_link = response.data.data.quotation.link_pdf;
      this.quote.tax = response.data.data.quotation.iva == 1 ? true : false;
      this.quote.tax_value = response.data.data.quotation.percentage_iva;
      this.quote.details.date_valid = moment(
        response.data.data.quotation.date_validity
      ).format("LL");
      this.quote.details.date_send = moment(
        response.data.data.quotation.date_send
      ).format("LL");
      this.quote.details.currency = response.data.data.quotation.currency;
      this.quote.discount = parseFloat(response.data.data.quotation.discount);
      this.quote.status = response.data.data.quotation.status;
      /* Cargar datos de nota */
      if (response.data.data.quotes.length > 0) {
        this.quote.details.notes = response.data.data.quotes[0].description;
      }

      /* Cargar datos de dueño de cotizacion */
      this.quote.owner.address = response.data.data.owner.address;
      this.quote.owner.company = response.data.data.owner.company;
      this.quote.owner.last_name = response.data.data.owner.last_name;
      this.quote.owner.name = response.data.data.owner.name;
      this.quote.owner.page = response.data.data.owner.page;
      this.quote.owner.email = response.data.data.quotation.owner.email;

      /* Datos de cliente */
      this.quote.clients = [];
      let tempClients = [];
      let tempObjectClients = {
        email: response.data.data.quotation.client.email,
        name: response.data.data.quotation.client.name,
        last_name:response.data.data.quotation.client.last_name,
        company:
          response.data.data.quotation.client.company != undefined
            ? response.data.data.quotation.client.company.name
            : "",
      };
      tempClients.push(tempObjectClients);
      this.quote.clients = tempClients;
      this.quote.items = [];
      this.quote.items_text = [];
      /* Formatear productos y textos */
      response.data.data.items.forEach((element) => {
        switch (element.type) {
          case 1:
            /* if(element.product.client_select == 1){ */
            var tempProd = this.formatItem(element.product, "product");
            /* if (tempProd.suscription.active === true) {
              tempProd.optional.select = true;
            } else {
              tempProd.optional.select = false;
            }
            tempProd.is_client_select = element.product.client_select; */
            this.quote.items.push(tempProd);
            /* } */
            break;

          case 2:
            this.quote.items.push(this.formatItem(element.text, "text"));
            break;

          default:
            break;
        }
      });
      this.quote.items.forEach((element, index) => {
        if (element.type == "producto") {
          this.calculate(element.price, "price", index);
        }
      });
      /* Fin formatear productos y textos */

      /* Formatear firma digital si existe */
      if (response.data.data.quotation.signature != null) {
        let tempSignature = JSON.parse(response.data.data.quotation.signature);
        this.quote.details.signature.datetime = tempSignature.datetime;
        this.quote.details.signature.user_agent = tempSignature.user_agent;
        this.quote.details.signature.ip = tempSignature.ip;
        this.quote.details.signature.mail = tempSignature.email;
        if (tempSignature.owner_id) {
          this.quote.details.signature.approve_owner = tempSignature.owner_id
            ? true
            : false;
          this.quote.details.signature.approve_user_id = tempSignature.owner_id;
        }
      }
    },
    calculate(string, field, index) {
      let item = this.quote.items[index];

      try {
        let value = eval(string);
        field === "qty"
          ? (item.quantity.amount = parseFloat(value))
          : (item.price = parseFloat(value));
      } catch (error) {
        return parseFloat(string);
      }
      this.setTotal(index);
    },
    /* Setear total */
    setTotal(index) {
      let item = this.quote.items[index];
      item.total = parseFloat(this.getProductTotal(index));
    },
    /* Obtener total de un producto */
    getProductTotal(index) {
      let item = this.quote.items[index];
      return parseFloat(
        item.quantity.amount *
          item.price *
          (item.commission.active ? 1 + item.commission.amount / 100 : 1) *
          (item.discount.active ? 1 - item.discount.amount / 100 : 1)
      ).toFixed(2);
    },
    /* Obtener items que son seleccionables o tienen cantidad modificable para poder mandar a servicio de actualizacion */
    getEditableItems() {
      let tempObjects = [];
      this.quote.items.forEach((element) => {
        if (element.type == "producto") {
          if (element.optional.active || element.quantity.edit) {
            let obj = {
              id: element.id,
              quantity: element.quantity.amount,
              is_selected: element.optional.select == true ? 1 : 0,
            };
            tempObjects.push(obj);
          }
        }
      });
      return tempObjects;
    },
  },
};
</script>

<style lang="scss" scoped>
.quote-status-info {
  color: #ffffff;
  .status-title {
    font-size: 24px;
    font-weight: bold;
  }
  .status-text {
    font-size: 15px;
  }
  &.approved {
    background-color: #6ec343;
  }
  &.rejected {
    background-color: #eb314e;
  }
  &.expired {
    background-color: #bb70f0;
  }
}
.secondary-padding {
  padding: 50px 80px;
  box-sizing: border-box;
}
</style>
